import type { Configuration, PopupRequest } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID || '18a2c300-b493-4837-a293-015508c28170';
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID || 'f7e0e8e5-6cc3-4908-8031-7754c87ac987';

/** Detect if we're running inside an iframe */
export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    // If cross-origin, we're definitely in an iframe
    return true;
  }
};

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    allowRedirectInIframe: true,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};
